export default class Prize
{
  constructor(titles, year) 
  {
    // {} instead of array to support stringify
    this.titles = titles;

    this.year = year;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; } // Titles

    if(result) result = Boolean(this.year);
    
    return result;
  }
}